/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./deviceDetails.vue?vue&type=template&id=aee701f8&scoped=true&"
import script from "./deviceDetails.vue?vue&type=script&lang=js&"
export * from "./deviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./deviceDetails.vue?vue&type=style&index=0&id=aee701f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee701f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VDialog,VIcon,VRow,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
